import React from 'react';
import { Button } from 'antd';
import styles from './default-button.module.css';
import type { MouseEventHandler } from 'react';

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactElement[] | React.ReactElement | string;
  onClick?: MouseEventHandler<HTMLElement>;
  style?: React.CSSProperties | undefined;
  type?: 'primary' | 'secondary' | 'ghost' | 'white';
};

const buttonStyle = {
  primary: styles.primaryButton,
  secondary: styles.defaultButton,
  ghost: styles.ghostButton,
  white: styles.whiteButton,
};

const DefaultButton: React.FC<Props> = ({
  icon,
  children,
  onClick,
  style,
  type = 'secondary',
}) => {
  return (
    <Button
      className={buttonStyle[type]}
      icon={icon}
      onClick={onClick}
      style={style}
    >
      {children}
    </Button>
  );
};

export default DefaultButton;
